export default (template, input = []) => {
    const newTemplate = template || '%s';
    const newInput = Array.isArray(input) ? input.slice() : [input];
    return newTemplate.replace(/%s/g, () => newInput.shift());
};
//# sourceMappingURL=interpolateString.js.map